__turbopack_context__.v({
  "shareLinkButton": "ShareLinkButton-module__wayRZW__shareLinkButton",
  "shareLinkOverlay": "ShareLinkButton-module__wayRZW__shareLinkOverlay",
  "shareLinkWrapper": "ShareLinkButton-module__wayRZW__shareLinkWrapper",
});
